import React from 'react';
import AppBarTitle from "./AppBarTitle";

const LoadingAppBarTitle = ({value, title, fallback}) => {
    if (!value)
        return <AppBarTitle title={fallback}/>;
    return <AppBarTitle title={title(value)}/>
};

export default LoadingAppBarTitle;